import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { push } from 'connected-react-router'
import { withJob } from 'react-jobs'
import { bindPromiseCreators } from '../../../../../utils/routines'
import {
  createFetchRequiredDocumentsPromise,
  createcheckDocumentsPromise
} from '../../../routines'
import {
  withFetchRequiredDocumentsSaga,
  withCheckDocumentsSaga,
  withCreateHaciendasSaga,
  withUploadFilesSaga
} from '../../../saga'
import {
  isHaciendaBlocked
} from '../../../selectors'

const mapStateToProps = createStructuredSelector({
  isHaciendaBlocked
})
const mapDispatchToProps = dispatch => ({
  ...bindPromiseCreators({
    fetchRequiredDocuments: createFetchRequiredDocumentsPromise,
    checkDocuments: createcheckDocumentsPromise
  }, dispatch),
  ...bindActionCreators({
    redirect: push
  }, dispatch)
})
const connector = connect(mapStateToProps, mapDispatchToProps)

async function work({ fetchRequiredDocuments, application }) {
  return fetchRequiredDocuments(application.id)
}

const job = withJob({
  work
})

export default compose(
  withFetchRequiredDocumentsSaga,
  withCheckDocumentsSaga,
  withCreateHaciendasSaga,
  withUploadFilesSaga,
  connector,
  job
)
